
import "./quality-control.css";
import lubas from "../images/lubas-tank.jpg"



const Lubas = () => {
    return (
        <>

            <div className="qc-container">
                <h1 className="qc-title">LUBAS TANK FARM</h1>

                <p className="qc-subtitle">40.000.000 LITERS OF PRODUCTS ARE ALWAYS IN STOCK</p>

                <div className="qc-image-wrapper">
                    <img
                        src={lubas}
                        alt="Quality Control"
                        className="qc-image"
                    />
                </div>

                <div className="qc-content ">
                    {/* <p>


                        All the lubricants are produced in-house.
                    </p> */}

                    
                </div>
            </div>
            
        </>



    );
};

export default Lubas;